<template>
  <div class="label">
    <div class="label-content" style="background: transparent;">
      <RadioGroup v-model="type" type="button" style="margin-bottom:10px;">
        <Radio :label="5" @click.native="getList(5)">擅长领域</Radio>
        <Radio :label="6" @click.native="getList(6)">服务地区</Radio>
      </RadioGroup>
      <Table
        :border="false"
        row-key="id"
        :columns="columns"
        :data="list"
        max-height='700'
        no-data-text="暂无数据"
      >
        <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
        <template slot-scope="{ row, index }" slot="value">{{row.value}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
          <span style="display: inline-block;padding: 0 5px;">|</span>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
    </div>
    <!-- 修改展商置顶 -->

    <labelAdd 
      :show="show"
      :actionType="type"
      @finish="getList(type)"
      @close="show=false;"
    />

    <labelEdit
      v-if="editShowFlag"
      :show="editShowFlag"
      :data="editInfo"
      @close="editShowFlag=false;editInfo={};"
      @finish="getList(type)"
    />

  </div>
</template>

<script>
import labelAdd from "../components/label-add.vue";
import labelEdit from "../components/label-edit.vue";
import { mapActions } from "vuex";

export default {
  name: "host-set-label",
  data() {
    return {
      columns: [
        {
          title: "标签类别",
          key: "name",
          align: "center",
        },
        {
          title: "标签内容",
          key: "value",
          align: "center",
        },
        {
          title: "排序",
          key: "showIndex",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      type: 5,
      list: [],
      show: false,
      editShowFlag: false,
      editInfo: {},
    };
  },
  components: {
    labelAdd,
    labelEdit
  },
  computed: {
    option() {
      return {
        ExhibitionId: this.exhibitionInfo.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex
      };
    },
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.getList(this.type);
  },
  methods: {
    ...mapActions({
      getActionType:'hostSetModule/getActionType',
      delActionType:'hostSetModule/delActionType'
    }),
    async getList(id) {
      this.list = await this.getActionType(id);
      if (id === 5 && this.list && this.list.length > 0) {
        this.list.map(c => {
          c.name = "擅长领域";
        })
      }
      if (id === 6 && this.list && this.list.length > 0) {
        this.list.map(c => {
          c.name = "服务地区";
        })
      }
      console.log(this.list,'list');
    },
    async delItem(item) { 
      let result = await this.delActionType(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.getList(this.type);
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    showAdd() { // 新增
      this.show = true;
    },
    editShow(item) { // 编辑
      this.editShowFlag = true;
      this.editInfo = item;
    },
  }
};
</script>

<style scoped lang="scss">
.label {
  min-width: 1000px;
  min-height: 500px;
  padding: 30px;
}
</style>
